import styles from "./button.module.scss";
import MuiButton from "@mui/material/Button";
import classnames from "classnames";
import PropTypes from "prop-types";
import { Icon } from "ui";

export const Button = ({ children, className, ...props }) => {
  const { active, endIcon, rounded, provider, startIcon, ...rest } = props;

  if (props.hidden) return null;

  return (
    <MuiButton
      {...rest}
      startIcon={startIcon && <Icon name={startIcon} />}
      endIcon={endIcon && <Icon name={endIcon} />}
      className={classnames(styles.root, className, {
        [styles.disableElevation]: props.disableElevation,
        [styles.contained]: !props.variant,
        [styles[props.color]]: props.color,
        [styles[props.size]]: props.size,
        [styles[props.variant]]: props.variant,
        [styles.disabled]: props.disabled,
        [styles.fullWidth]: props.fullWidth,
        [styles.rounded]: rounded,
        [styles[provider]]: provider,
        [styles.loading]: props.loading,
        [styles.active]: active,
      })}
    >
      {!props.loading && children}
    </MuiButton>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  endIcon: PropTypes.string,
  startIcon: PropTypes.string,
  variant: PropTypes.oneOf(["text", "outlined", "contained"]),
  color: PropTypes.oneOf([
    "default",
    "primary",
    "secondary",
    "error",
    "info",
    "success",
    "warning",
  ]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
};
